import { STICKY_OVERRIDE } from './Z-INDEX';

export const FLEET_REPORTS_SELECT_STYLES = {
  control: (base) => ({
    ...base,
    borderColor: 'var(--third-gray) !important',
    boxShadow: 'none',
  }),
  indicatorsContainer: (base) => ({ ...base, paddingLeft: 0 }),
  indicatorSeparator: (base) => ({ ...base, display: 'none' }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'var(--background-gray) !important',
  }),
  multiValueLabel: (base) => ({
    ...base,
    backgroundColor: 'transparent !important',
  }),
  multiValueRemove: (base) => ({
    ...base,
    backgroundColor: 'transparent !important',
  }),
  valueContainer: (base) => ({ ...base, paddingRight: 0 }),
};

export const BASIC_SELECT_STYLES = {
  indicatorSeparator: (base) => ({ ...base, visibility: 'hidden' }),
  control: (base) => ({
    ...base,
    outline: 'none',
    boxShadow: 'none',
  }),
};

export const BASIC_SELECT_STYLES_Z_INDEX_OVERRIDE = {
  control: (base) => ({
    ...base,
    outline: 'none',
    boxShadow: 'none',
  }),
  indicatorSeparator: (base) => ({ ...base, visibility: 'hidden' }),
  menu: (base) => ({ ...base, zIndex: STICKY_OVERRIDE }),
};

export const GTEMPLATE_REMINDER_SIGNAL_HEADER_DROPDOWN = {
  clearIndicator: (base) => ({
    ...base,
    color: 'var(--danger) !important',
  }),
  container: (base) => ({ ...base, zIndex: STICKY_OVERRIDE }),
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--text-muted) !important',
  }),
  indicatorSeparator: (base) => ({ ...base, display: 'none' }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--text-muted) !important',
    marginLeft: 0,
    marginRight: 0,
  }),
};
